import { render, staticRenderFns } from "./RestaurantPage.vue?vue&type=template&id=12b85f53&scoped=true&"
import script from "./RestaurantPage.vue?vue&type=script&lang=js&"
export * from "./RestaurantPage.vue?vue&type=script&lang=js&"
import style0 from "./RestaurantPage.vue?vue&type=style&index=0&id=12b85f53&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12b85f53",
  null
  
)

/* custom blocks */
import block0 from "./RestaurantPage.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports